import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_budget_register_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  currency: fromDatatype.VarcharDatatypeInterface;
  balance_amt: fromDatatype.NumericDatatypeInterface;
  initial_allocated_amt: fromDatatype.NumericDatatypeInterface;
  latest_allocated_amt: fromDatatype.NumericDatatypeInterface;
  actual_used_amt: fromDatatype.NumericDatatypeInterface;
  latest_used_amt: fromDatatype.NumericDatatypeInterface;
  reserved_amt: fromDatatype.NumericDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  period_start: fromDatatype.TimestampTzDatatypeInterface;
  period_end: fromDatatype.TimestampTzDatatypeInterface;
  budget_account_type: fromDatatype.VarcharDatatypeInterface;
  budget_default_side: fromDatatype.VarcharDatatypeInterface;
  budget_fiscal_year_code: fromDatatype.VarcharDatatypeInterface;
  budget_fiscal_period_code: fromDatatype.VarcharDatatypeInterface;
  category_hdr_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_0_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_3_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_4_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_5_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_6_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_7_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_8_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_9_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_10_guid: fromDatatype.GuidDataFieldInterface;
  profit_center_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_budget_register_RowClass
  implements bl_fi_budget_register_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  currency: fromDatatype.VarcharDatatypeInterface;
  balance_amt: fromDatatype.NumericDatatypeInterface;
  initial_allocated_amt: fromDatatype.NumericDatatypeInterface;
  latest_allocated_amt: fromDatatype.NumericDatatypeInterface;
  actual_used_amt: fromDatatype.NumericDatatypeInterface;
  latest_used_amt: fromDatatype.NumericDatatypeInterface;
  reserved_amt: fromDatatype.NumericDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  period_start: fromDatatype.TimestampTzDatatypeInterface;
  period_end: fromDatatype.TimestampTzDatatypeInterface;
  budget_account_type: fromDatatype.VarcharDatatypeInterface;
  budget_default_side: fromDatatype.VarcharDatatypeInterface;
  budget_fiscal_year_code: fromDatatype.VarcharDatatypeInterface;
  budget_fiscal_period_code: fromDatatype.VarcharDatatypeInterface;
  category_hdr_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_0_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_1_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_2_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_3_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_4_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_5_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_6_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_7_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_8_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_9_guid: fromDatatype.GuidDataFieldInterface;
  category_hdr_10_guid: fromDatatype.GuidDataFieldInterface;
  profit_center_guid: fromDatatype.GuidDataFieldInterface;
}
